"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirstStep = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _ui = require("../../../../../../ui");
var _Actions = require("./Actions");
var _utils = require("../../../../../../../utils");
var _excluded = ["onPrevStepClick", "onNextStepClick"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var google = function google(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.625 12.0016C5.625 10.8126 5.95261 9.69867 6.52177 8.74491V4.69922H2.47608C0.870375 6.78459 0 9.32611 0 12.0016C0 14.6772 0.870375 17.2187 2.47608 19.3041H6.52177V15.2584C5.95261 14.3046 5.625 13.1907 5.625 12.0016Z",
    fill: "#FBBD00"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 18.3768L9.1875 21.1893L12 24.0018C14.6756 24.0018 17.217 23.1315 19.3024 21.5257V17.4844H15.261C14.2989 18.0556 13.1804 18.3768 12 18.3768Z",
    fill: "#31AA52"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.52225 15.2578L2.47656 19.3035C2.79447 19.7164 3.14064 20.1118 3.51522 20.4864C5.78172 22.7528 8.79517 24.0011 12.0005 24.0011V18.3761C9.67436 18.3761 7.63563 17.1236 6.52225 15.2578Z",
    fill: "#31AA52"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 12.0004C24 11.2704 23.9339 10.5389 23.8035 9.82652L23.698 9.25H12V14.875H17.6931C17.1402 15.9747 16.2902 16.872 15.261 17.483L19.3024 21.5244C19.7153 21.2065 20.1106 20.8603 20.4853 20.4857C22.7518 18.2192 24 15.2057 24 12.0004Z",
    fill: "#3C79E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.5078 7.49217L17.005 7.98933L20.9825 4.01189L20.4853 3.51473C18.2188 1.24823 15.2054 0 12 0L9.1875 2.8125L12 5.625C13.7028 5.625 15.3037 6.28809 16.5078 7.49217Z",
    fill: "#EB4132"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.0005 5.625V0C8.79522 0 5.78177 1.24823 3.51522 3.51469C3.14064 3.88927 2.79447 4.28466 2.47656 4.69758L6.52225 8.74326C7.63567 6.8775 9.67441 5.625 12.0005 5.625Z",
    fill: "#EB4132"
  }));
};
google.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var apple = function apple(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.62357 7.22161C8.74757 7.22161 7.39157 6.22561 5.96357 6.26161C4.07957 6.28561 2.35157 7.35361 1.37957 9.04561C-0.576427 12.4416 0.875573 17.4576 2.78357 20.2176C3.71957 21.5616 4.82357 23.0736 6.28757 23.0256C7.69157 22.9656 8.21957 22.1136 9.92357 22.1136C11.6156 22.1136 12.0956 23.0256 13.5836 22.9896C15.0956 22.9656 16.0556 21.6216 16.9796 20.2656C18.0476 18.7056 18.4916 17.1936 18.5156 17.1096C18.4796 17.0976 15.5756 15.9816 15.5396 12.6216C15.5156 9.81361 17.8316 8.46961 17.9396 8.40961C16.6196 6.47761 14.5916 6.26161 13.8836 6.21361C12.0356 6.06961 10.4876 7.22161 9.62357 7.22161ZM12.7436 4.38961C13.5236 3.45361 14.0396 2.14561 13.8956 0.849609C12.7796 0.897609 11.4356 1.59361 10.6316 2.52961C9.91157 3.35761 9.28757 4.68961 9.45557 5.96161C10.6916 6.05761 11.9636 5.32561 12.7436 4.38961Z",
    fill: "currentColor"
  }));
};
apple.defaultProps = {
  width: "19",
  height: "24",
  viewBox: "0 0 19 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var QRCode = (0, _styledComponents.default)(_ui.QRCode)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 36px auto 41px;\n"])));
var ShadowButton = (0, _styledComponents.default)(_ui.ShadowButton)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), _utils.mediaQuery.lessThan('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 40px;\n  "]))));
var P = (0, _styledComponents.default)(_ui.P)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-bottom: 23px;\n"])));
var FirstStep = function FirstStep(_ref) {
  var onPrevStepClick = _ref.onPrevStepClick,
    onNextStepClick = _ref.onNextStepClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, _extends({}, props, {
    className: "d-flex flex-column flex-grow-1"
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(P, {
    className: "text-center"
  }, t('setUpAuthenticatorFirstStep')), /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, null, /*#__PURE__*/_react.default.createElement(ShadowButton, {
    iconPosition: "left",
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: google
    }),
    onClick: function onClick() {
      return window.open('https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2', '_blank');
    },
    wide: true
  }, t('googlePlay'))), /*#__PURE__*/_react.default.createElement(_ui.Col, null, /*#__PURE__*/_react.default.createElement(ShadowButton, {
    iconPosition: "left",
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: apple
    }),
    onClick: function onClick() {
      return window.open('https://apps.apple.com/us/app/google-authenticator/id388497605', '_blank');
    },
    wide: true
  }, t('appStore')))), /*#__PURE__*/_react.default.createElement(QRCode, {
    className: "d-block",
    size: 178,
    value: "http://onelink.to/9nxd6g"
  })), /*#__PURE__*/_react.default.createElement(_Actions.Actions, {
    className: "mt-auto",
    prevBtnProps: {
      children: t('cancel'),
      onClick: onPrevStepClick
    },
    nextBtnProps: {
      onClick: onNextStepClick
    }
  }));
};
exports.FirstStep = FirstStep;